// https://github.com/tailwindlabs/heroicons/issues/69

export default function LogoutIcon({ className = "w-6 h-6" }) {
  return (
    <svg
      className={className}
      viewBox="0 0 28 28"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.33325 14L1.7476 13.5315L1.37278 14L1.7476 14.4685L2.33325 14ZM12.8333 14.75C13.2475 14.75 13.5833 14.4142 13.5833 14C13.5833 13.5858 13.2475 13.25 12.8333 13.25V14.75ZM6.41427 7.69817L1.7476 13.5315L2.9189 14.4685L7.58557 8.63521L6.41427 7.69817ZM1.7476 14.4685L6.41427 20.3019L7.58557 19.3648L2.9189 13.5315L1.7476 14.4685ZM2.33325 14.75H12.8333V13.25H2.33325V14.75Z"
        fill="currentColor"
        stroke="none"
      />
      <path d="M11.6667 9.48724V8.05516C11.6667 6.43681 11.6667 5.62764 12.1407 5.06815C12.6147 4.50866 13.4128 4.37563 15.0092 4.10958L18.6804 3.49771C21.9234 2.9572 23.545 2.68694 24.6059 3.58563C25.6667 4.48433 25.6667 6.12825 25.6667 9.41608V18.5839C25.6667 21.8717 25.6667 23.5156 24.6059 24.4143C23.545 25.313 21.9234 25.0428 18.6804 24.5022L15.0092 23.8904C13.4128 23.6243 12.6147 23.4913 12.1407 22.9318C11.6667 22.3723 11.6667 21.5631 11.6667 19.9448V18.7436" />
    </svg>
  );
}
